import type { ChangeEvent } from 'react'
import { useCallback } from 'react'
import { SwitchBase } from '@instacart/ids-tooling'
import { Accordion, Text } from '@retailer-platform/shared-components'
import { useDashMessages } from '../../../../intl/intl.hooks'
import { useRetailerAgentEnabled } from '../../../../modules/retailer-agent/hooks/useRetailerAgentEnabled'

export const RetailerAgentEnabled = () => {
  const { enabled, setEnabled } = useRetailerAgentEnabled()

  const handleSwitchChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setEnabled(event.target.checked)
    },
    [setEnabled]
  )

  const i18n = useDashMessages({
    retailerAgentEnabledTitle: 'app.admin.controlPanel.setting.retailerAgentEnabled.title',
    retailerAgentEnabledDesc: 'app.admin.controlPanel.setting.retailerAgentEnabled.description',
  })

  const title = (
    <div css={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      {i18n.retailerAgentEnabledTitle}

      <div css={{ flex: 1 }} />

      <div css={{ overflow: 'hidden' }}>
        <SwitchBase
          name="retailerAgentEnabledSwitch"
          id="retailerAgentEnabledSwitch"
          checked={enabled}
          onClick={evt => evt.stopPropagation()}
          onChange={handleSwitchChange}
        />
      </div>
    </div>
  )

  return (
    <Accordion showContentBackground={true} title={title}>
      <Text size="small">{i18n.retailerAgentEnabledDesc}</Text>
    </Accordion>
  )
}
